import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid } from '@mui/material';

import { useFetchInitCashierReports } from './hooks'
import { FilterForm } from './FilterForm'
import { ModalModule } from  './ModalModule'

export const CashierReports = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitCashierReports({location, paramsURL})

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    // ------------------------------------------------ Actions

    return (
        <AllowedAccess permissions={['255_REPORTES']} renderAuthFailed={<p>Error</p>}>
            <ModalModule useFetchInit={useFetchInit}/>
            <div className="content">
                <div className="panel-body">
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Card style={{zIndex:'1'}}>
                                <CardContent>
                                    
                                    <div className='h4 mt-1 mb-1'> Cajas: Reportes </div>
                                    <div className="border-bottom border-dark"></div>

                                    <div className="pt-4"></div>
                                    <FilterForm useFetchInit={useFetchInit} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </AllowedAccess>
    )
}
